var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"dark":"","absolute":"","color":"indigo darken-4"}},[_c('h3',[_vm._v("AUDIDOC")])]),_c('v-main',{staticClass:"mt-15"},[_c('BuscarEstadoDocumentos',{attrs:{"token":_vm.$route.params.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }